import {h} from 'hyperapp'

export default () =>
    <footer class="row">
        <a href="https://www.ingenieur-imac.fr/">
            <p>League IMAC ©2020</p>
        </a>
    </footer>
